export default __webpack_public_path__ + "static/uCall x Tai Chinh_page-0001-1de3ef7d0f43275a6ba231c2275bac36.jpg";